




























































import { Component, Mixins } from "vue-property-decorator";
import PasswordsMixin from "@/mixins/http/PasswordsMixin";
import DisplayErrors from "@/components/DisplayErrors.vue";
import RequestData from "@/store/types/RequestData";
import store from "@/store";
import { RegisterHttp } from "@/utils/Decorators";
import UnauthorizedPage from "@/views/UnauthorizedPage.vue";

@Component({ components: { DisplayErrors, UnauthorizedPage } })
export default class ResetPassword extends Mixins(PasswordsMixin) {
  private password = "";
  private confirmPassword = "";
  private passwordResetted = false;
  private error = false;

  @RegisterHttp("reset") http!: RequestData;

  get resetToken() {
    return this.$route.query.token as string;
  }

  get passwordValid() {
    return this.password.length >= 8 && this.confirmPassword === this.password;
  }

  goToLogin() {
    this.$router.push({ name: "login" });
  }

  login(email: string, password: string) {
    store.dispatch("login", { email, password }).then(
      (user) => {
        window.location.reload();
      },
      (err) => {
        this.error = err;
      }
    );
  }

  submit() {
    const data = {
      token: this.resetToken,
      password: this.password,
    };
    this.resetPassword(data, "reset").then(
      (data) => {
        this.passwordResetted = true;

        if (data.email) {
          this.login(data.email, this.password);
        } else {
          this.goToLogin();
        }
      },
      (err) => {
        this.error = true;
      }
    );
  }
}
